import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Col,
  Row,
  Label,
  ModalHeader,
  Input,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../helpers/datePickerConfig';
import { formatDate, parseDateString, addMonths, getMonthName } from '../../../helpers/dateUtils';
import matriculacionApiService from '../../../services/http/matriculacionApiService';
import { getItem, STORAGE_KEYS } from '../../../services/storage';
import useSoloLecturaMatriculas from '../../../hooks/useSoloLecturaMatriculas';
import logger from '../../../services/logger';

const ModalRecibo = ({ isVisible, setIsVisible, matricula, setReloadRecibos }) => {
  const soloLectura = useSoloLecturaMatriculas();
  // Obtener la fecha actual-..SS
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const empresaId = getItem(STORAGE_KEYS.ENROLLMENT)?.headquarter;
  const [fecha, setFecha] = useState('');
  const [forma, setForma] = useState('Contado Efectivo');
  const [idForma, setIdForma] = useState(0);
  const [importe, setImporte] = useState(0);
  const [concepto, setConcepto] = useState('');
  const [periodico, setPeriodico] = useState(false);
  const [descuento, setDescuento] = useState(0);
  const [cuotas, setCuotas] = useState(1);
  const [tipo, setTipo] = useState(0);
  const [data, setData] = useState([]);
  const [dataType, setDataType] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataMetodosPago = await matriculacionApiService.cargarMetodosPago({
          headquarter: 'CEDESCA',
        });
        setData(dataMetodosPago);
      } catch (error) {
        setData([]);
      }

      try {
        const dataListaTipoCliente = await matriculacionApiService.cargarListaTipoCliente({
          headquarter: empresaId,
        });

        // Crear el nuevo objeto
        const nuevoObjeto = { id: 0, nombre: 'Alumno' };

        // Añadir el nuevo objeto al inicio del arreglo
        dataListaTipoCliente.unshift(nuevoObjeto);
        setDataType(dataListaTipoCliente);
      } catch (error) {
        setDataType([]);
      }
    };

    fetchData();
  }, [empresaId]);

  const handleModalState = () => {
    setIsVisible(!isVisible);
  };

  const handleFecha = (value) => {
    if (!value) {
      setFecha('');
      return;
    }
    const formattedDate = formatDate(value, 'dd/MM/yyyy');
    setFecha(formattedDate);
  };

  const handleOnChangeImporte = (e) => {
    setImporte(e.target.value);
  };
  const handleOnChangeCuotas = (e) => {
    setCuotas(e.target.value);
  };
  const handleOnChangeDescuento = (e) => {
    setDescuento(e.target.value);
  };
  const handleOnChangePeriodico = () => {
    setPeriodico(!periodico);
  };
  const handleOnChangeConcpeto = (e) => {
    setConcepto(e.target.value);
  };

  const handleOnChangeForma = (e) => {
    const [id, descripcion] = e.target.value.split('-');
    setForma(descripcion);
    setIdForma(parseInt(id, 10));
  };

  const handleOnChangeTipo = (e) => {
    setTipo(e.target.value);
  };

  const handleAdd = async () => {
    try {
      const nuevosRecibos = [];
      for (let i = 0; i < cuotas; i++) {
        const fechaBase = parseDateString(fecha, 'dd/MM/yyyy');
        if (!fechaBase) {
          logger.error('Error: No se pudo parsear la fecha');
          return;
        }
        const nuevaFechaVencimiento = addMonths(fechaBase, i);
        const formattedFechaVencimiento = formatDate(nuevaFechaVencimiento, 'dd/MM/yyyy');
        const mesNombre = getMonthName(nuevaFechaVencimiento);
        const importeActual = importe - (importe * descuento) / 100;
        let tipoCliente = 1;

        if (tipo > 0) {
          tipoCliente = 2;
        }
        const nuevoRecibo = {
          NUM_Recibo: 'xxx',
          Num_factura: 'xxx',
          Concepto: periodico ? `Cuota mes de ${mesNombre}` : concepto,
          Fecha_Emision: `${day}/${month}/${year}`,
          Fecha_vencimiento: formattedFechaVencimiento,
          Fecha_cobro: 'Sin definir',
          Neto: periodico ? (importeActual / cuotas).toFixed(2) : importeActual,
          Bruto: periodico ? (importeActual / cuotas).toFixed(2) : importeActual,
          Tipo_cliente: 'A',
          tipoCliente,
          ccodcli: tipoCliente === 1 ? matricula : tipo,
          Forma_de_pago: forma,
          Estado: 'Pendiente',
          idPago: idForma,
          descuento,
          memo: `Aplicado descuento del ${descuento}%`,
        };
        nuevosRecibos.push(nuevoRecibo);
      }

      if (nuevosRecibos.length) {
        await matriculacionApiService.addRecibo({
          headquarter: empresaId,
          recibos: nuevosRecibos,
          numMatricula: matricula,
        });
      }

      setReloadRecibos(true);
      setIsVisible(false);
    } catch (error) {
      logger.error('Añadir recibo/s error =>', error);
    }
  };

  return (
    <div>
      <Modal isOpen={isVisible} centered size="lg">
        <ModalHeader>Añadir recibo</ModalHeader>
        {data.length > 0 && (
          <ModalBody>
            <Form>
              <Row>
                <Col md="4">
                  <Label>Fecha de vencimiento</Label>
                </Col>
                <Col md="5">
                  <Label>Forma de pago</Label>
                </Col>
                <Col md="3">
                  <Label>Importe</Label>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md="4">
                  <DatePicker
                    id="fecha"
                    name="fecha"
                    selected={fecha ? parseDateString(fecha, 'dd/MM/yyyy') : null}
                    onChange={handleFecha}
                    dateFormat="dd/MM/yyyy"
                    locale="es"
                    className="form-control"
                    wrapperClassName="w-100"
                  />
                </Col>
                <Col md="5">
                  <Input
                    type="select"
                    name="formaDePago"
                    id="formaDepago"
                    onChange={handleOnChangeForma}
                  >
                    {data.map((datos) => (
                      <option key={datos.id} value={`${datos.id}-${datos.descripcion}`}>
                        {datos.descripcion}
                      </option>
                    ))}
                  </Input>
                </Col>

                <Col md="3">
                  <Input
                    type="number"
                    name="importe"
                    id="importe"
                    onChange={handleOnChangeImporte}
                    min="0"
                    defaultValue={importe}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md="4">
                  <Label>Descuento %</Label>
                  <Input
                    type="number"
                    name="descuento"
                    id="descuento"
                    onChange={handleOnChangeDescuento}
                    min="0"
                    max="100"
                    defaultValue={descuento}
                  />
                  {descuento < 0 || descuento > 100 ? (
                    <span className="text-danger tiny">Descuento entre el 0% y el 100%</span>
                  ) : (
                    ''
                  )}
                </Col>
                <Col md="5">
                  <Label>Periódico</Label>
                  <div className="form-check">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      name="periodico"
                      id="periodico"
                      onChange={handleOnChangePeriodico}
                    />
                    <Label className="form-check-label" htmlFor="periodico">
                      Sí
                    </Label>
                  </div>
                </Col>
                <Col md="3">
                  <Label>Número de cuotas</Label>
                  <Input
                    type="number"
                    name="cuotas"
                    id="cuotas"
                    onChange={handleOnChangeCuotas}
                    min="1"
                    disabled={!periodico}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Label>Tipo de cliente</Label>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md="5">
                  <Input
                    type="select"
                    name="tipoCliente"
                    id="tipoCliente"
                    onChange={handleOnChangeTipo}
                  >
                    {dataType.map((datos) => (
                      <option key={datos.id} value={datos.id}>
                        {datos.nombre}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Label>Concepto</Label>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md="12">
                  <Input
                    type="text"
                    name="concepto"
                    id="concepto"
                    onChange={handleOnChangeConcpeto}
                    disabled={periodico}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="4">
                  Importe con descuento aplicado: {importe - (importe * descuento) / 100} €
                </Col>
              </Row>
            </Form>
          </ModalBody>
        )}

        <ModalFooter>
          <Button
            color="success"
            disabled={(() => {
              const isRedsys = (forma || '').toUpperCase() === 'REDSYS';
              const num = Number(importe);
              const importeInvalido =
                importe === '' ||
                Number.isNaN(num) ||
                num < 0 ||
                (!isRedsys && num === 0);
              return (
                importeInvalido ||
                (periodico === false && concepto.length === 0) ||
                fecha.length === 0 ||
                descuento < 0 ||
                descuento > 100 ||
                soloLectura
              );
            })()}
            onClick={handleAdd}
          >
            Añadir
          </Button>
          <Button color="danger" onClick={handleModalState}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

ModalRecibo.propTypes = {
  isVisible: PropTypes.bool,
  setIsVisible: PropTypes.func,
  matricula: PropTypes.object,
  setReloadRecibos: PropTypes.func,
};

export default ModalRecibo;
